import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Database16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M12.5 4.25H7.5V5.75H12.5V4.25Z' fill='currentColor' />
    <path
      d='M5.5 5C5.5 5.55228 5.05228 6 4.5 6C3.94772 6 3.5 5.55228 3.5 5C3.5 4.44772 3.94772 4 4.5 4C5.05228 4 5.5 4.44772 5.5 5Z'
      fill='currentColor'
    />
    <path
      d='M5.5 11C5.5 11.5523 5.05228 12 4.5 12C3.94772 12 3.5 11.5523 3.5 11C3.5 10.4477 3.94772 10 4.5 10C5.05228 10 5.5 10.4477 5.5 11Z'
      fill='currentColor'
    />
    <path d='M7.5 10.25H12.5V11.75H7.5V10.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.25 7.5C0.25 7.73452 0.312851 7.97179 0.439457 8.17845C0.313914 8.43359 0.25 8.7166 0.25 9V13.5C0.25 14.1544 0.763536 14.75 1.4375 14.75H14.5625C15.2365 14.75 15.75 14.1544 15.75 13.5V9C15.75 8.7166 15.6861 8.43359 15.5605 8.17845C15.6872 7.97179 15.75 7.73452 15.75 7.5V3C15.75 2.10032 15.0629 1.25 14.125 1.25H1.875C0.937069 1.25 0.25 2.10032 0.25 3V7.5ZM1.75 3V7.25H14.25V3C14.25 2.80165 14.1685 2.75019 14 2.75L2.00581 2.75385C1.84045 2.74937 1.75 2.80519 1.75 3ZM2 8.75H14C14.1671 8.74803 14.25 8.82767 14.25 9V13.25H1.75V9C1.75 8.82767 1.83287 8.74803 2 8.75Z'
      fill='currentColor'
    />
  </Svg>
);

Database16.displayName = 'Database16';
export default Database16;
